/**
 * Printed artwork — the ISOFIX mark Ankaplastik prints, drawn as line art in
 * the ISO pictogram grammar (4-unit grid, round joins), reused wherever the
 * mark appears: the print-process films (cliché, pad, part), the pad hero
 * scene, the blog's transfer strip. Colour comes from currentColor.
 */

/**
 * The ISOFIX-style child-seat mark as an SVG group in a 100-unit box centred
 * on 0,0 — for use inside another <svg>. Strokes are set by the caller's CSS.
 *
 * @param {{ className?: string, mirrored?: boolean }} props
 */
export function IsofixGlyph({ className = '', mirrored = false }) {
  return (
    <g className={className} transform={mirrored ? 'scale(-1 1)' : undefined}>
      <path d="M40 8V-26Q40 -40 26 -40H-26Q-40 -40 -40 -26V26Q-40 40 -26 40H14" />
      <path d="M-27 -27V8Q-27 24 -11 24H17V13" />
      <path d="M-13 -7V3Q-13 10 -6 10H12" />
      <circle cx="-6" cy="-19" r="6.5" fill="currentColor" stroke="none" />
      <circle cx="30" cy="18" r="3.75" fill="currentColor" stroke="none" />
      <path d="M30 27V40" />
    </g>
  )
}
